import React from 'react';
import {renderToStaticMarkup} from 'react-dom/server';
import {formatTime} from 'utils';
import PrintableTranscript from 'components/transcript/print';

const getFileName = (videoTitle, type = 'transcript') => {
    const typeLabel = {transcript: 'Transcript', caption: 'Captions'}[type];
    return videoTitle || typeLabel;
};

export const buildTranscript = (elementList, title) => {
    const segments = elementList.get('segments');

    let transcript = `${title}\n\n`;

    segments.forEach((segment, segmentIndex) => {
        const displaySpeaker = segment.get('speakerChange') || segment.get('path').first() === 0;
        if (displaySpeaker && segment.get('speaker')) transcript += `${segment.get('speaker').get('displayAs')}\n`;

        transcript += `${formatTime(segment.get('startTime'))}\n`;

        segment.get('sequences').forEach(sequence => {
            const lastTokenIndex = sequence.get('tokens').size - 1;
            sequence.get('tokens').forEach((token, tokenIndex) => {
                transcript += token.get('displayAs') + (tokenIndex === lastTokenIndex ? ' ' : '');
            });
        });

        if (segmentIndex !== (segments.size - 1)) transcript += '\n\n';
    });

    // Branding
    transcript += '\n\n\n';
    transcript += 'cielo24 | what’s in your video? | cielo24.com';
    return transcript;
};

const downloadFile = (blob, fileName) => {
    const {saveAs} = require('file-saver');
    saveAs(blob, fileName);
};

export const triggerTranscriptDownload = (elementList, format, videoTitle) => {
    const filename = getFileName(videoTitle);
    const transcript = exports.buildTranscript(elementList, videoTitle);
    const blob = new Blob([transcript], {type: 'text/plain;charset=utf-8'});
    return downloadFile(blob, `${filename}.${format}`);
};

export const triggerCaptionDownload = async (caption, videoTitle) => {
    const filename = getFileName(videoTitle, 'caption');
    const blob = await fetch(caption.get('href')).then(response => response.blob());
    return downloadFile(blob, `${filename}.${caption.get('format')}`);
};

export const triggerTranscriptPrint = (elementList, {rtl, videoTitle}) => {
    const transcript = renderToStaticMarkup(
        <PrintableTranscript title={getFileName(videoTitle)} rtl={rtl} elementList={elementList} />,
    );

    const printWindow = window.open('', '_blank');

    if (printWindow) {
        printWindow.document.write(transcript);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
    }
};



// WEBPACK FOOTER //
// ./scripts/export.js